module.exports = __webpack_public_path__ + "media/images/img-hobby-15-d5207a0e.jpg";